'use strict';

module.exports = ['$scope', '$rootScope', 'SupplierSvc', 'MaterialSvc', '$modalInstance', 'config', function ($scope, $rootScope, SupplierSvc, MaterialSvc, $modalInstance, config) {

    $scope.saveMaterialClick = function () {
        $scope.disableInput = true;

        //$scope.material.plant = $scope.plant
        //console.log("plantid", $scope);
        $scope.material.is_output_material = !!config.output_material;


        MaterialSvc.create($scope.material, $scope.plant).success(function (data) {

                // add supplier name instead of id
                var suppIds = $.map($scope.suppliers, function (val, i) {
                    return val.id;
                });
                var index = suppIds.indexOf(data.supplier);
                if (index != -1) {
                    data.supplier = $scope.suppliers[suppIds.indexOf(data.supplier)].name;
                }

                if (typeof(config.callback) == 'function') {
                    config.callback(data);
                }
                $modalInstance.close();
                $scope.disableInput = false;
            })
            .error(function (data) {
                $scope.error = data;
                $scope.disableInput = false;
            });
    };

    $scope.cancelClick = function () {
        $modalInstance.close();
    };

    $scope.inputOrOutput = !!config.output_material ? "Output" : "Input";

    //
    //  Load Dependent Data
    //
    SupplierSvc.list().success(function (data) {
        $scope.suppliers = data;
    });

    // ------------------
    // Initialization
    // ------------------

    var randomColor = $rootScope.colorPalette[Math.floor(Math.random() * $rootScope.colorPalette.length)];

    $scope.suppliers = [];
    $scope.material = {
        system_color: randomColor
    };
}];
